import {
  InvoicingDocumentTypeUnion,
  useGetDocumentSeriesDefinitionListQuery,
} from '@dms/api/finance';

import {getDocumentSystemSeriesId} from '../utils/getDocumentSystemSeriesId';
import {useGetCurrentBranch} from './useGetCurrentBranch';

export const useGetInitialDocumentSeriesId = (
  invoicingDocumentType: InvoicingDocumentTypeUnion
) => {
  const {
    data: documentSeries,
    isLoading: isLoadingDocumentSeries,
    isError: isDocumentSeriesError,
  } = useGetDocumentSeriesDefinitionListQuery();
  const {activeBranchId} = useGetCurrentBranch();

  const documentSeriesId =
    documentSeries?.find(
      (documentSeries) =>
        documentSeries.invoicingDocumentType === invoicingDocumentType &&
        documentSeries.branchId === activeBranchId
    )?.id ?? getDocumentSystemSeriesId(documentSeries, invoicingDocumentType);

  return {
    documentSeriesId,
    isLoadingDocumentSeries,
    isDocumentSeriesError,
  };
};
